import { useChipWithInputModel } from './chip-with-input.model'
import type { IChipWithInput } from './chip-with-input.types'
import { ChipWithInputView } from './chip-with-input.view'

export function ChipWithInput({ placeholderText, charLimit = 50, onSubmit }: IChipWithInput) {
  const chipWithInputModel = useChipWithInputModel(onSubmit)

  return <ChipWithInputView placeholderText={placeholderText} charLimit={charLimit} {...chipWithInputModel} />
}
